import React, { useEffect, useState } from 'react'
import { levelgroupProps } from './levelgroup-interface'
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import Levelitem from './levelitem';
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { DeleteOutlined } from '@ant-design/icons';

const Levelgroup = ({ details, index, openLevel, removeLevel }: levelgroupProps) => {
	const [collapsed, setCollapsed] = useState(false)

	useEffect(() => {
		setCollapsed(details.open)
	}, [details.open])


	return (
		<div className=''>
			<div className='flex items-center justify-end'>
				<p className='flex items-center cursor-pointer text-appcolorred w-fit'
					onClick={() => {
						removeLevel(index)
					}}
				>
					<span className='mr-1'>
						Remove Level
					</span>
					<DeleteOutlined />
				</p>
			</div>
			<div className='flex items-center justify-between w-full custom-grey-bg-faint py-[0.75rem] px-[1.25rem] rounded-[20px] cursor-pointer'
				onClick={() => {
					openLevel(index, !collapsed)
				}}
			>
				<div className='flex items-center text-base leading-[26px] font-semibold '>
					<p className='text-appcolorblack mr-[0.5rem]'>Level {index + 1}:</p>
					<p className='text-appcolorgreyfaintfour'>{details.name}</p>
				</div>

				<div className='flex items-center'>
					{
						collapsed ?
							<DownOutlined />
							:
							<UpOutlined />
					}
				</div>
			</div>
			<div className='px-2 pt-4'>
				{
					collapsed ?
						<>
							<Droppable droppableId={details._id}>
								{(provided) => (
									<div
										className=''
										{...provided.droppableProps}
										ref={provided.innerRef}
									>
										{
											details.children.map((item: any, index: number) => (
												<Draggable
													draggableId={item._id}
													index={index}
													key={item._id}
												>
													{(provided) => (
														<div
															{...provided.dragHandleProps}
															{...provided.draggableProps}
															ref={provided.innerRef}
														>
															<Levelitem
																key={item._id}
																index={index}
																details={item}
															/>
														</div>
													)}
												</Draggable>
											))
										}
										{provided.placeholder}
									</div>
								)}
							</Droppable>
						</>
						:
						null
				}

			</div>
		</div>
	)
}

export default Levelgroup